import { Camera } from '@phosphor-icons/react';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../Store/Reducers';

interface ImageUploadProps {
    children?: React.ReactNode;
    imagePreview: any;
    camRemoveImage: boolean;
    handleRemoveImage?: () => void;
    handleImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    hasResetOption?: boolean;
    handleResetImage?: () => void;
}

function ImageUpload({
    children,
    imagePreview,
    camRemoveImage,
    handleRemoveImage,
    handleImageChange,
    hasResetOption = false,
    handleResetImage,
}: ImageUploadProps) {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const i18n = useSelector((state: RootState) => state.i18n.i18n);

    return (
        <div className="flex gap-5 items-center">
            <div
                className="relative w-[50px] h-[50px] md:w-[100px] md:h-[100px] flex-shrink-0 rounded-full border border-layout-borderColor flex justify-center items-center bg-layout-bodyBackground cursor-pointer group"
                onClick={() => {
                    if (!hasResetOption && !imagePreview) {
                        document.getElementById('avatarInput')?.click();
                    } else {
                        setIsDropdownOpen(!isDropdownOpen);
                    }
                }}
            >
                {imagePreview ? (
                    <div className="w-full h-full rounded-full relative">
                        <img src={imagePreview} alt="" className="w-full h-full object-cover rounded-full" />
                        <div
                            className={`absolute inset-0 bg-black rounded-full bg-opacity-50 opacity-0 group-hover:opacity-100 ${
                                isDropdownOpen ? 'opacity-100' : ''
                            } flex justify-center items-center`}
                        >
                            <Camera id="cameraIcon" size={24} className="text-white cursor-pointer" />
                        </div>
                    </div>
                ) : (
                    <span className="text-layout-textcolor text-center">
                        <span className="hidden md:inline">
                            {i18n.translate({
                                id: 'imageUpload.chooseImage',
                                sourceName: 'Main',
                            })}
                        </span>
                        <div
                            className={`absolute inset-0 bg-black rounded-full bg-opacity-50 opacity-70 hover:opacity-100 block md:hidden ${
                                isDropdownOpen ? 'opacity-100' : ''
                            } flex justify-center items-center`}
                        >
                            <Camera id="cameraIcon" size={24} className="text-white cursor-pointer" />
                        </div>
                    </span>
                )}
                {isDropdownOpen && (
                    <div
                        id="imageDropdown"
                        className="absolute bg-layout-bodyBackground min-w-[200px] w-fit top-full mt-2 left-0 bg-white border border-layout-borderColor rounded shadow-lg z-10"
                    >
                        {imagePreview ? (
                            <>
                                <button
                                    className="block px-4 py-2 bg-layout-bodyBackground text-sm text-layout-textcolor hover:bg-layout-hoverColor w-full text-left"
                                    onClick={() => {
                                        document.getElementById('avatarInput')?.click();
                                        setIsDropdownOpen(false);
                                    }}
                                >
                                    {i18n.translate({
                                        id: 'imageUpload.changeImage',
                                        sourceName: 'Main',
                                    })}
                                </button>
                                {camRemoveImage && (
                                    <button
                                        className="block px-4 py-2 bg-layout-bodyBackground text-sm text-layout-textcolor hover:bg-layout-hoverColor w-full text-left"
                                        onClick={(e) => {
                                            handleRemoveImage && handleRemoveImage();
                                            setIsDropdownOpen(false);
                                        }}
                                    >
                                        {i18n.translate({
                                            id: 'imageUpload.deleteImage',
                                            sourceName: 'Main',
                                        })}
                                    </button>
                                )}
                                {hasResetOption && (
                                    <button
                                        className="block px-4 py-2 bg-layout-bodyBackground text-sm text-layout-textcolor hover:bg-layout-hoverColor w-full text-left"
                                        onClick={(e) => {
                                            handleResetImage && handleResetImage();
                                            setIsDropdownOpen(false);
                                        }}
                                    >
                                        {i18n.translate({
                                            id: 'imageUpload.resetImage',
                                            sourceName: 'Main',
                                        })}
                                    </button>
                                )}
                            </>
                        ) : (
                            <>
                                <button
                                    className="block px-4 py-2 bg-layout-bodyBackground text-sm text-layout-textcolor hover:bg-layout-hoverColor w-full text-left"
                                    onClick={() => {
                                        document.getElementById('avatarInput')?.click();
                                        setIsDropdownOpen(false);
                                    }}
                                >
                                    {i18n.translate({
                                        id: 'imageUpload.addImage',
                                        sourceName: 'Main',
                                    })}
                                </button>
                                {hasResetOption && (
                                    <button
                                        className="block px-4 py-2 bg-layout-bodyBackground text-sm text-layout-textcolor hover:bg-layout-hoverColor w-full text-left"
                                        onClick={(e) => {
                                            setIsDropdownOpen(false);
                                            handleResetImage && handleResetImage();
                                        }}
                                    >
                                        {i18n.translate({
                                            id: 'imageUpload.resetImage',
                                            sourceName: 'Main',
                                        })}
                                    </button>
                                )}
                            </>
                        )}
                    </div>
                )}
                <input
                    type="file"
                    accept="image/*"
                    id="avatarInput"
                    className="hidden"
                    onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file) {
                            handleImageChange(e);
                        }
                    }}
                />
            </div>
            {children}
        </div>
    );
}

export default ImageUpload;
